import { useCallback, useEffect } from "react";
import { useAuth } from "react-oidc-context";
async function hasInternetAccess(urlToCheck) {
    if (navigator.onLine) {
        try {
            const v = await fetch(urlToCheck, {
                method: "OPTIONS",
            });
            return v.ok;
        }
        catch (e) {
            return false;
        }
    }
    else {
        return false;
    }
}
const getOpenIdConfigFromIssuer = (issuer) => issuer ? `${issuer}/.well-known/openid-configuration` : undefined;
export const useRenewToken = (logout, issuer, maxWaitingTimeMs = 140 * 1000, attemptIntervalMs = 2 * 1000) => {
    const auth = useAuth();
    const attemptTokenRenew = useCallback(() => {
        new Promise((resolve, reject) => {
            let currentWaitingTime = 0;
            const interval = setInterval(async () => {
                // navigator.onLine only checks for network connectivity but not internet access. Need to manually check
                hasInternetAccess(getOpenIdConfigFromIssuer(issuer) ?? window.location.origin).then((res) => {
                    if (res) {
                        clearInterval(interval);
                        resolve();
                    }
                    else {
                        currentWaitingTime += attemptIntervalMs;
                        if (currentWaitingTime > maxWaitingTimeMs) {
                            clearInterval(interval);
                            reject(new Error("No internet access"));
                        }
                    }
                });
            }, attemptIntervalMs);
        }).then(() => {
            auth.signinSilent()
                .then((res) => {
                if (!res) {
                    logout({ auth });
                }
            })
                .catch(() => {
                logout({ auth });
            });
        })
            .catch(() => {
            logout({ auth });
        });
    }, [logout, maxWaitingTimeMs, attemptIntervalMs, issuer]);
    useEffect(() => auth.events.addAccessTokenExpiring(attemptTokenRenew), [attemptTokenRenew, auth]);
    useEffect(() => auth.events.addAccessTokenExpired(attemptTokenRenew), [attemptTokenRenew, auth]);
};
//# sourceMappingURL=renewToken.js.map